export default __webpack_public_path__ + "static/media/close_icon.7d09d0a7.svg";